import { render, staticRenderFns } from "./SociosNormativaExtraescolares.vue?vue&type=template&id=8d22a0b0&"
import script from "./SociosNormativaExtraescolares.vue?vue&type=script&lang=js&"
export * from "./SociosNormativaExtraescolares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports